<template>
  <p v-if="note" class="ExtraOptinNote">{{ note }}</p>
</template>

<script>
  export default {
    name: 'extra-optin-note',

    props: {
      content: {
        type: String,
        default: null
      }
    },

    computed: {
      note () {
        return this.content && this.content.trim()
      }
    }
  }
</script>

<style lang="scss">
  .ExtraOptinNote {
    font-size: .12rem;
    margin-left: .32rem;
  }
</style>
